export default __webpack_public_path__ + "static/media/step1Img.9ad8de2e.svg";